import React from 'react';
import { Droplet, Phone, Mail, MessageCircle, MapPin } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Vehicle', href: '#vehicle' },
    { name: 'Suitable For', href: '#suitable-for' },
    { name: 'Requirements', href: '#requirements' },
    { name: 'Insurance Guidance', href: '#insurance-guidance' },
    { name: 'FAQs', href: '#faqs' },
    { name: 'Contact', href: '#contact' },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-950 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-sky-600 rounded-lg flex items-center justify-center">
                <Droplet className="w-6 h-6 text-white" />
              </div>
              <div>
                <span className="font-bold text-xl text-white">WFP</span>
                <span className="font-medium text-lg text-slate-400"> Sussex</span>
              </div>
            </div>
            <p className="text-slate-400 max-w-md mb-6">
              Window cleaning vehicle made available for short-term lease to experienced trade professionals. 
              Ford Transit Custom fitted with 650L tank, hot water system, and electric hose reels. 
              Vehicle insured by the user.
            </p>
            <div className="flex items-center gap-2 text-slate-400">
              <MapPin className="w-4 h-4" />
              <span>{businessInfo.location}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-white mb-4">Quick Links</h4>
            <nav className="space-y-3">
              {quickLinks.map((link) => (
                <button
                  key={link.name}
                  onClick={() => scrollToSection(link.href)}
                  className="block text-slate-400 hover:text-sky-400 transition-colors duration-200"
                >
                  {link.name}
                </button>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-white mb-4">Contact</h4>
            <div className="space-y-4">
              <a
                href={`tel:${businessInfo.phone}`}
                className="flex items-center gap-3 text-slate-400 hover:text-sky-400 transition-colors duration-200"
              >
                <Phone className="w-5 h-5" />
                <span>{businessInfo.phone}</span>
              </a>
              <a
                href={`https://wa.me/${businessInfo.whatsapp.replace(/\s/g, '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-slate-400 hover:text-green-400 transition-colors duration-200"
              >
                <MessageCircle className="w-5 h-5" />
                <span>WhatsApp</span>
              </a>
              <a
                href={`mailto:${businessInfo.email}`}
                className="flex items-center gap-3 text-slate-400 hover:text-amber-400 transition-colors duration-200"
              >
                <Mail className="w-5 h-5" />
                <span>{businessInfo.email}</span>
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-slate-800 pt-8">
          {/* Legal Clarification */}
          <p className="text-slate-500 text-xs text-center mb-6 max-w-3xl mx-auto">
            Trade users only. Vehicles are provided under a short-term lease agreement and are insured by the user. This is not a public self-drive hire service.
          </p>
          
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} WFP Sussex. All rights reserved.
            </p>
            <p className="text-slate-500 text-sm text-center md:text-right">
              Vehicle specification may vary subject to maintenance or upgrades. No poles or cleaning consumables supplied.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
